import { useColorMode } from "@chakra-ui/react";
import { APP_THEME } from "@root/constants";
import React from "react";

function useCustomTheme() {
  const { colorMode } = useColorMode();
  const lightColor = "#000000";
  const darkColor = "#FFFFFF";
  return {
    color: colorMode === APP_THEME.DARK ? darkColor : lightColor,
    isDarkTheme: colorMode === APP_THEME.DARK,
  };
}

export default useCustomTheme;
